import React, { useEffect, useState } from "react";
import SearchBar from "../Main/searchBar";
import "./viewBooking.css";
import { ReactComponent as BackIcon } from "../../Assets/Categories/BackIcon.svg";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getBookingsListById } from "../../Redux/Actions/bookingActions";
import H2Element from "../../Global Functions/h2Element";
import { ReactComponent as View } from "../../Global Icons/View Modal.svg";
import PriceDetailModal from "../../Global Functions/priceDetailModal";
import { DateToLocale, ToFirstCapital } from "../../Utils/helpers";

const ViewBookingsPaymentExec = () => {
  const { id } = useParams();

  const [pricePopup, setPricePopup] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getBookingsListById(id));
  }, [id, dispatch]);

  const { booking } = useSelector((state) => state.bookings || {});

  const priceModalHandler = () => {
    setPricePopup(!pricePopup);
  };

  useEffect(() => {
    if (booking) {
      console.log("Booking Data after fetch:", booking);
    }
  }, [booking]);

  return (
    <div className="overall-booking-container">
      <div className="search_booking">
        <SearchBar />
      </div>

      <div className="flex-container align-center gap-10">
        <div onClick={() => navigate(-1)}>
          <BackIcon style={{ cursor: "pointer" }} />
        </div>

        <div>
          <h2 className="margin-0">{booking?.data?.booking_id}</h2>
          <div className="flex-container">
            <h4 className="margin-0">
              {booking?.data?.project?.project_name || "No Data"}
            </h4>
          </div>
        </div>
      </div>

      <div className="overall_details">
        {/* Top Project & Booking Details */}
        <div className="top-container">
          <div className="">
            <img
              style={{
                width: "200px",
                height: "auto",
                borderRadius: "8px",
                objectFit: "cover",
                display: "block",
                margin: "0 auto",
              }}
              src={booking?.data?.project?.project_type?.image || ""}
              alt="project-img"
            />
            <H2Element
              label="Project Id"
              bgBlue={true}
              value={booking?.data?.project?.project_id || "No Data"}
            />
            <H2Element
              label="Project Type"
              bgBlue={true}
              value={
                booking?.data?.project?.project_type
                  ? booking.data.project.project_type.name
                  : "No Data"
              }
            />
          </div>
          <hr className="project_hr" />
          <div className="">
            <H2Element
              bgBlue={true}
              label="Project Name"
              value={booking?.data?.project?.project_name || "No Data"}
            />
            <H2Element
              label="User Name"
              value={booking?.data?.user?.name || "No Data"}
              bgBlue={true}
            />
            <H2Element
              label="User Id"
              value={
                booking?.data?.user?.user_id ||
                booking?.data?.user?._id ||
                "No Data"
              }
              bgBlue={true}
            />
          </div>
          <hr className="project_hr" />
          <div className="">
            <H2Element
              label="Booking Amount"
              value={
                booking?.data?.booking_amount_currency &&
                booking?.data?.booking_amount
                  ? `${booking.data.booking_amount_currency} ${
                      Math.floor(booking.data.booking_amount * 100) / 100
                    }`
                  : "No Data"
              }
              bgBlue={true}
            />
            <H2Element
              label="Booking Date"
              value={DateToLocale(booking?.data?.created_at)}
              bgBlue={true}
            />
          </div>
          <hr className="project_hr" />
          <div className="">
            <H2Element
              label="Payment Status"
              value={ToFirstCapital(booking?.data?.payment_status)}
              bgBlue={true}
            />
            <H2Element
              label="Payment Method"
              value={ToFirstCapital(booking?.data?.payment_method)}
              bgBlue={true}
            />
          </div>
          <hr className="project_hr" />
          <div className="">
            <H2Element
              label="Builder Name"
              value={booking?.data?.builder?.brand_name || "No Data"}
              bgBlue={true}
            />
            <H2Element
              label="Builder Id"
              value={booking?.data?.builder?._id || "No Data"}
              bgBlue={true}
            />
          </div>
          <hr className="project_hr" />
          <div className="">
            <H2Element
              label="Booking Pdf url"
              value={
                (
                  <a
                    href={booking?.data?.booking_pdf_url}
                    download={`Booking-${booking?.user?.name}`}
                  >
                    Download PDF
                  </a>
                ) || "No Data"
              }
              bgBlue={true}
            />
            <H2Element
              label="Payment Executive"
              value={
                booking?.data?.payment_executive?.name
                  ? `${booking.data.payment_executive.name}`
                  : "No Data"
              }
              bgBlue={true}
            />
            <H2Element
              label="Payment Executive Number"
              value={
                booking?.data?.payment_executive?.contact_number
                  ? `${booking.data.payment_executive.contact_number}`
                  : "No Data"
              }
              bgBlue={true}
            />
          </div>
        </div>

        {/* User Details */}
        <div className="user_details">
          <div style={{ display: "flex", alignItems: "center" }}>
            <h3 style={{ color: "white" }}>User Details</h3>
            <hr />
          </div>
          <div className="top-container_user">
            <div className="">
              <H2Element
                label="User Name"
                value={booking?.data?.user?.name || "No Data"}
                bgBlue={true}
              />
              <H2Element
                label="User ID"
                value={
                  booking?.data?.user?.user_id ||
                  booking?.data?.user?._id ||
                  "No Data"
                }
                bgBlue={true}
              />
              <H2Element
                label="Email"
                value={booking?.data?.user?.email || "No Data"}
                bgBlue={true}
              />
            </div>
            <div className="">
              <H2Element
                label="Contact Number"
                value={
                  booking?.data?.user?.country_code &&
                  booking?.data?.user?.contact_number
                    ? `${booking.data.user.country_code} ${booking.data.user.contact_number}`
                    : "No Data"
                }
                bgBlue={true}
              />
              <H2Element
                label="Profile Image"
                value={
                  booking?.data?.user?.profile_image ? (
                    <img
                      src={booking.data.user.profile_image}
                      alt="User Profile"
                      style={{ width: "100px", borderRadius: "8px" }}
                    />
                  ) : (
                    "No Data"
                  )
                }
                bgBlue={true}
              />
            </div>
          </div>
        </div>

        {/* Property Details */}
        <div className="property_details">
          <div style={{ display: "flex", alignItems: "center" }}>
            <h3 style={{ color: "white" }}>Property Details</h3>
            <hr />
          </div>
          {Array.isArray(booking?.data?.properties) &&
            booking.data.properties.map((property) => (
              <div className="top-container_property" key={property._id}>
                <div className="">
                  <H2Element
                    label="Completion Date"
                    value={
                      new Date(property?.created_at).toLocaleString() ||
                      "No Data"
                    }
                    bgBlue={true}
                  />
                  <H2Element
                    label="Property ID"
                    value={property?.property_id || "No Data"}
                    bgBlue={true}
                  />
                  <H2Element
                    label="Construction Status"
                    value={property?.construction_status || "No Data"}
                    bgBlue={true}
                  />
                  <H2Element
                    label="Phases"
                    value={
                      booking?.data?.phases
                        ? booking.data.phases.map((item, index) => (
                            <h4 className="margin-0" key={index}>
                              {item.name}
                            </h4>
                          ))
                        : []
                    }
                    bgBlue={true}
                  />
                </div>

                <div className="">
                  <H2Element
                    label="Property Type"
                    value={ToFirstCapital(property?.property_type)}
                    bgBlue={true}
                  />
                  <H2Element
                    label="Booked Properties"
                    value={booking?.data?.properties?.length || "No Data"}
                    bgBlue={true}
                  />
                  <H2Element
                    label="Possession Date"
                    value={
                      property?.possession_date
                        ? property.possession_date
                        : "No Data"
                    }
                    bgBlue={true}
                  />
                  <H2Element
                    label="Tower Name"
                    value={
                      property?.tower_name
                        ? property.tower_name
                        : "No Tower name"
                    }
                    bgBlue={true}
                  />
                  <H2Element
                    label="Floor Number"
                    value={
                      property?.floor !== undefined && property?.floor !== null
                        ? property.floor
                        : "No Data"
                    }
                    bgBlue={true}
                  />
                </div>

                <div className="">
                  <H2Element
                    label="Unit Type"
                    value={property?.unit || []}
                    bgBlue={true}
                  />
                  <H2Element
                    label="Furnishing"
                    value={ToFirstCapital(property?.furnishing_status)}
                    bgBlue={true}
                  />
                  <H2Element label="Price Details" bgBlue={true}></H2Element>
                  <div style={{ cursor: "pointer" }}>
                    <View onClick={() => priceModalHandler()} />
                  </div>
                  {pricePopup && (
                    <PriceDetailModal
                      propertyData={property}
                      onClick={() => priceModalHandler()}
                    />
                  )}
                </div>

                <div className="">
                  <H2Element
                    label="Cover Photos"
                    value={
                      property?.cover_photos?.length ? (
                        <div
                          style={{
                            display: "flex",
                            gap: "8px",
                            flexWrap: "wrap",
                          }}
                        >
                          {property.cover_photos.map((photo) => (
                            <img
                              key={photo._id}
                              src={photo.url}
                              alt={`Cover ${photo.index + 1}`}
                              style={{
                                width: "100px",
                                height: "70px",
                                objectFit: "cover",
                                borderRadius: "8px",
                              }}
                            />
                          ))}
                        </div>
                      ) : (
                        "No Photos"
                      )
                    }
                    bgBlue={true}
                  />
                </div>

                <div className="">
                  <H2Element
                    label="Project Type"
                    value={
                      booking?.data?.project?.project_type
                        ? booking.data.project.project_type.name
                        : "No Data"
                    }
                    bgBlue={true}
                  />
                  <H2Element
                    label="Booking Status"
                    value={ToFirstCapital(property?.status)}
                    bgBlue={true}
                  />
                  <H2Element
                    label="Transaction Currency"
                    value={property?.currency || "No Data"}
                    bgBlue={true}
                  />
                </div>

                <div className="">
                  <H2Element
                    label="Unit Number"
                    value={property?.unitno ? property.unitno : "No Data"}
                    bgBlue={true}
                  />
                  <br />
                  <H2Element
                    label="Address"
                    value={`${
                      booking?.data?.country?.country_name
                        ? `${booking?.data?.city?.city_name}, ${booking?.data?.state?.state_name}, ${booking?.data?.country?.country_name}`
                        : "No Data"
                    }`}
                    bgBlue={true}
                  />
                </div>

                {/* ✅ Added View All Details Button */}
                <div style={{ marginTop: "10px" }}>
                  <button
                    style={{
                      backgroundColor: "#1890ff",
                      color: "#fff",
                      border: "none",
                      padding: "6px 12px",
                      borderRadius: "6px",
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      navigate(
                        `/manage_properties/view/${property?.property_id}`
                      )
                    }
                  >
                    View All Details
                  </button>
                </div>
              </div>
            ))}
        </div>

        <div className="property_details" style={{ marginTop: "30px" }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <h3 style={{ color: "white" }}>Payment Details</h3>
            <hr />
          </div>
          <div className="top-container">
            <H2Element
              label="Total Amount"
              value={
                booking?.data?.total
                  ? `${booking.data.currency || ""} ${
                      Math.floor(booking.data.total * 100) / 100
                    }`
                  : "No Data"
              }
              bgBlue={true}
            />
            <H2Element
              label="Sub Total"
              value={
                booking?.data?.sub_total
                  ? `${booking.data.currency || ""} ${
                      Math.floor(booking.data.sub_total * 100) / 100
                    }`
                  : "No Data"
              }
              bgBlue={true}
            />
            <H2Element
              label="Location Charges"
              value={
                // Check if booking has preferred_location_charges, else fallback to first property
                booking?.data?.preferred_location_charges !== undefined
                  ? `${booking.data.currency || ""} ${
                      Math.floor(
                        booking.data.preferred_location_charges * 100
                      ) / 100
                    }`
                  : booking?.data?.properties &&
                    booking.data.properties.length > 0 &&
                    booking.data.properties[0].preferred_location_charges !==
                      undefined
                  ? `${booking.data.currency || ""} ${
                      Math.floor(
                        booking.data.properties[0].preferred_location_charges *
                          100
                      ) / 100
                    }`
                  : "No Data"
              }
              bgBlue={true}
            />
            <H2Element
              label="Additional Charges"
              value={
                booking?.data?.additional_charges
                  ? `${booking.data.currency || ""} ${
                      Math.floor(booking.data.additional_charges * 100) / 100
                    }`
                  : "No Data"
              }
              bgBlue={true}
            />
            <H2Element
              label="Coupon Discount"
              value={
                booking?.data?.coupon_discount &&
                booking.data.coupon_discount > 0
                  ? `${booking.data.currency || ""} ${
                      booking.data.coupon_discount
                    }`
                  : "No Coupon Applied"
              }
              bgBlue={true}
            />
            <H2Element
              label="Gift Card Discount"
              value={
                booking?.data?.gift_discount && booking.data.gift_discount > 0
                  ? `${booking.data.currency || ""} ${
                      booking.data.gift_discount
                    }`
                  : "No Gift Card Applied"
              }
              bgBlue={true}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewBookingsPaymentExec;
